import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.2",
  viewBox: "0 0 25.229 25.233"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M20.451 4.779H.602M10.002 14.182H2.167a1.567 1.567 0 0 1-1.565-1.567V2.167A1.567 1.567 0 0 1 2.167.6h16.717a1.567 1.567 0 0 1 1.567 1.567V10M18.362 7.913h-3.135M5.825 10.003H2.69M7.914 7.913H2.69M18.361 15.182v6.267M21.495 18.316h-6.268M18.921 24.522l.578-.219c2.748-1.045 5.131-3.682 5.131-6.622v-3.546a1.09 1.09 0 0 0-.655-1 16.532 16.532 0 0 0-5.635-1.045 16.223 16.223 0 0 0-5.591 1.045 1.091 1.091 0 0 0-.656 1v3.545c0 2.94 2.338 5.575 5.086 6.622l.578.219a1.634 1.634 0 0 0 1.164.001Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }